<div class="new_leave_modal">
  <div class="new_leave_modal-toolbar" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="16px">
    <div class="new_leave_modal-title" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
      <mat-icon class="fa-lg primary" fontSet="fa" fontIcon="fa-calendar-plus"></mat-icon>
      <div class="new_leave_modal-title_content" fxLayout="column">
        <!-- titulo -->
        <h2 class="primary">
          {{ stepper?.selectedIndex === 0 ? ('leaves.addLeaveDialog.requestLeaveTitle' | transloco) : (
          stepper?.selectedIndex === 1 ? ('leaves.addLeaveDialog.requestVacationDaysTitle' | transloco) : (
          stepper?.selectedIndex === 2 ? ('leaves.addLeaveDialog.requestSummaryTitle' | transloco) : ''
          ))}}
        </h2>
        <h4 *ngIf="stepper?.selectedIndex === 0">
          {{ 'leaves.addLeaveDialog.chooseOptionLbl' | transloco }}
        </h4>
        <ng-container *ngIf="stepper?.selectedIndex === 1">
          <h4>
            {{ 'leaves.addLeaveDialog.completeInfoLbl' | transloco }}
          </h4>
          <h6>
            {{ 'leaves.addLeaveDialog.futurePeriodsInfoLbl' | transloco }}
          </h6>
        </ng-container>
        <h4 *ngIf="stepper?.selectedIndex === 2 ">
          {{ 'leaves.addLeaveDialog.confirmDataLbl' | transloco }}
        </h4>
      </div>
    </div>
    <!-- cerrar modal -->
    <button mat-icon-button mat-dialog-close [disabled]="isLoading">
      <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-times" fxLayout="row" fxLayoutAlign="center center">
      </mat-icon>
    </button>
  </div>

  <!-- loading -->
  <div class="new_leave_modal-loading" *ngIf="isLoading" fxLayout="row" fxLayoutAlign="center center">
    <mat-progress-spinner mode="indeterminate" color="primary">
    </mat-progress-spinner>
  </div>

  <!-- pasos licencias -->
  <mat-horizontal-stepper class="new_leave_modal-steps" #stepper [hidden]="isLoading">
    <!-- paso 1 - tipo  -->
    <mat-step class="new_leave_modal-step">
      <form class="new_leave_modal-form" [formGroup]="menuFormLeave">

        <mat-radio-group class="new_leave_modal-options" fxLayout="column" fxLayoutGap="16px"
          formControlName="selectedMenuLeave">

          <mat-radio-button value="AddVacation">
            <div [ngClass]="{'accent' :menuFormLeave.controls['selectedMenuLeave'].value ==='AddVacation'}"
              fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
              <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-umbrella-beach"></mat-icon>
              <div class="new_leave_modal-title_content" fxLayout="column">
                <h3 class="main-text">
                  {{ 'leaves.addLeaveDialog.requestVacationDaysTitle' | transloco }}
                </h3>
                <p class="side-text">
                  {{ (AvailableDays === 1 ? 'leaves.addLeaveDialog.availableDayLbl' : 'leaves.addLeaveDialog.availableDaysLbl') | transloco: { days: AvailableDays } }}
                </p>
                <i class="side-text muted">
                  "{{ 'leaves.addLeaveDialog.requestDaysHint' | transloco }}"
                </i>
              </div>
            </div>
          </mat-radio-button>

          <!-- <mat-radio-button value="AddSettlement" disabled title="aún no está disponible">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px"
              [ngClass]="{'accent' : menuFormLeave.controls['selectedMenuLeave'].value === 'AddSettlement'}">
              <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-money-check"></mat-icon>
              <div fxLayout="column">
                <h3 class="main-text">
                  Solicitar días de Vacaciones vencidas
                </h3>
                <p class="side-text">
                  {{ 'Tenés ' + AvailableDebth }}
                  {{AvailableDebth === 1 ? ' día disponible' : ' días disponibles'}}
                </p>
                <i class="side-text muted">
                  "Solicitá que se procesen los días acumulados de períodos anteriores"
                </i>
              </div>
            </div>
          </mat-radio-button> -->
        </mat-radio-group>

        <!-- paso 1 acciones -->
        <div class="new_leave_modal-actions" fxLayout="row-reverse" fxLayoutAlign="start center" fxLayoutGap="12px"
          fxFill>
          <button data-testid="next-btn-main" mat-raised-button matStepperNext color="primary" [disabled]="isLoading">{{ 'common.next' | transloco }}</button>
          <button data-testid="cancel-btn-main" mat-button mat-dialog-close>{{ 'common.cancelBtn' | transloco }}</button>
        </div>
      </form>
    </mat-step>

    <!-- paso 2 - carga -->
    <mat-step class="new_leave_modal-step">
      <ng-container *ngIf="menuFormLeave.controls['selectedMenuLeave'].value ==='AddVacation'">
        <form class="new_leave_modal-form" [formGroup]="durationFormLeave" fxLayout="column"
          fxLayoutAlign="center start" fxLayoutGap="16px">
          <mat-form-field class="new_leave_modal-field" appearance="fill" fxFill>
            <input data-testid="days-consumed-input"
                   #inputDays
                   matInput
                   type="number"
                   min="1"
                   [placeholder]="'leaves.addLeaveDialog.daysToConsumePlaceholder' | transloco"
                   (input)="validateInteger()"
                   (focusout)="focusOutFunction(inputDays)"
                   (change)="setEndDate()"
                   formControlName="DaysConsumed">
            <mat-label *ngIf="error !==''">  {{error}}</mat-label>
          </mat-form-field>

          <mat-form-field class="new_leave_modal-field" appearance="fill" fxFill>
            <mat-label>{{ 'leaves.addLeaveDialog.startDateLbl' | transloco }}</mat-label>
            <input data-testid="date-start-input" readonly matInput  [matDatepicker]="fechaInicia" [matDatepickerFilter]="FilterEfectiveTimes" [disabled]="error !==''"
              (dateChange)="setEndDate()" formControlName="StartDate" >
            <mat-datepicker-toggle matIconSuffix [for]="fechaInicia" data-testid="date-start-datepicker" id="fechaInicioCalendar">
              <mat-datepicker  #fechaInicia></mat-datepicker>
            </mat-datepicker-toggle>

          </mat-form-field>

          <mat-form-field class="new_leave_modal-field" appearance="fill" fxFill>
            <mat-label>{{ 'leaves.addLeaveDialog.endDateLbl' | transloco }}</mat-label>
            <input data-testid="date-end-input" disabled readonly matInput [matDatepicker]="fechaFin" [matDatepickerFilter]="FilterEfectiveTimes"
              formControlName="EndDate">
            <mat-datepicker-toggle data-testid="date-end-datepicker" matIconSuffix [for]="fechaFin" id="fechaFinCalendar">
              <mat-datepicker #fechaFin></mat-datepicker>
            </mat-datepicker-toggle>
          </mat-form-field>
          <div class="info-container" *ngIf="menuFormLeave.controls['selectedMenuLeave'].value === 'AddVacation'">
            <mat-icon fontSet="fa" fontIcon="fa-square-info"></mat-icon>
            <span class="info-text">{{ (rules?.useConsecutiveDays ? 'leaves.addLeaveDialog.consecutiveDaysInfo' : 'leaves.addLeaveDialog.workingDaysInfo') | transloco }}</span>
          </div>

          <!-- paso 2a acciones -->
          <div class="new_leave_modal-actions" fxLayout="row-reverse" fxLayoutAlign="start center" fxLayoutGap="12px"
            fxFill>
            <button data-testid="next-btn-summary" mat-raised-button (click)="goToSummaryVacation()" color="primary">{{ 'common.next' | transloco }}</button>
            <button data-testid="back-btn-summary" mat-button matStepperPrevious>{{ 'common.lastBtn' | transloco }}</button>
          </div>
        </form>
      </ng-container>

      <ng-container *ngIf="menuFormLeave.controls['selectedMenuLeave'].value === 'AddSettlement'">
        <form class="new_leave_modal-form" [formGroup]="daysFormLeave" fxLayout="column" fxLayoutAlign="center start"
          fxLayoutGap="16px">
          <mat-form-field class="new_leave_modal-field" appearance="fill" fxFill>
            <mat-label>{{ 'leaves.addLeaveDialog.daysToProcessLbl' | transloco }}</mat-label>
            <input  data-testid="days-process-input" matInput formControlName="DaysConsumed" mdInput type="number" id="DaysConsumed" min="1"
              [max]="AvailableDebth">
          </mat-form-field>

          <!-- paso 2b acciones -->
          <div class="new_leave_modal-actions" fxLayout="row-reverse" fxLayoutAlign="start center" fxLayoutGap="12px"
            fxFill>
            <button data-testid="next-btn-settlement" mat-raised-button (click)="goToSummarySettlement()" color="primary">{{ 'common.next' | transloco }}</button>
            <button data-testid="back-btn-settlement" mat-button matStepperPrevious>{{ 'common.lastBtn' | transloco }}</button>
          </div>
        </form>
      </ng-container>
    </mat-step>

    <!-- paso 3 - resumen -->
    <mat-step class="new_leave_modal-step">
      <form class="new_leave_modal-form" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="16px">
        <div class="new_leave_modal-resume_line" *ngIf="daysRequestsNow || diasConsumidos" fxLayout="column" fxFill>
          <span class="side">
            {{ 'leaves.addLeaveDialog.requestedDaysLbl' | transloco }}
          </span>
          <b class="main accent">
            {{ diasConsumidos }}
          </b>
        </div>
        <div class="new_leave_modal-resume_line" *ngIf="fechaInicio" fxLayout="column" fxFill>
          <span class="side">
            {{ 'leaves.addLeaveDialog.startDateLbl' | transloco }}
          </span>
          <b class="main accent">
            {{ fechaInicio | date:'dd/MM/yyyy' }}
          </b>
        </div>
        <div class="new_leave_modal-resume_line" *ngIf="fechaFin" fxLayout="column" fxFill>
          <span class="side">
            {{ 'leaves.addLeaveDialog.endDateLbl' | transloco }}
          </span>
          <b class="main accent">
            {{ fechaFin | date:'dd/MM/yyyy' }}
          </b>
        </div>

        <!-- paso 3 acciones -->
        <div class="new_leave_modal-actions" fxLayout="row-reverse" fxLayoutAlign="start center" fxLayoutGap="12px"
          fxFill>
          <button data-testid="send-btn-data" mat-raised-button (click)="sendFormData()" color="accent" [disabled]="isLoading">
            {{ 'leaves.addLeaveDialog.sendRequestBtn' | transloco }}
          </button>
          <button data-testid="back-btn-send" mat-button matStepperPrevious [disabled]="isLoading">{{ 'common.lastBtn' | transloco }}</button>
        </div>
      </form>
    </mat-step>
  </mat-horizontal-stepper>
</div>
